export default __webpack_public_path__ + "static/media/1280px-Download_on_the_App_Store_Badge_ES_RGB_blk.svg.de9007af.png";